<template>
  <v-layout class="maintenance" wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <div class="maintenance__header" mt-2>
          <h1 class="headline">{{ $t('auto.internalMaintenance') }}</h1>
          <v-btn
            v-if="$can('auto_internal_maintenance_payment_logs')"
            :to="{ name: 'maintenance-history' }"
            color="info mt-2 mr-3"
            depressed
            large
          >
            {{ $t('auto.maintenanceHistory.title') }}
          </v-btn>
        </div>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <internal-maintenance-table />
    </v-flex>
  </v-layout>
</template>

<script>
import InternalMaintenanceTable from '@/components/auto/InternalMaintenanceTable.vue';
import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  components: { InternalMaintenanceTable },
  beforeRouteEnter(to, from, next) {
    checkRouteAccess('auto_internal_maintenance_show', next, to);
  },
};
</script>

<style lang="scss">
.maintenance {
  &__header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__search {
    max-width: 400px;
    margin-bottom: 10px !important;
  }
}
</style>
